import { SCREEN_RESIZE } from '../../constant';

const initScreen = {
  width: document.documentElement.clientWidth,
  height: document.documentElement.clientHeight,
  fontSize: document.documentElement.style.fontSize,
};
const screenResize = (state = initScreen, action) => {
  const { type, data } = action;
  if (type === SCREEN_RESIZE) {
    return data;
  } else {
    return state;
  }
};

export { screenResize };
